<app-header />
<main
  cdkScrollable
  class="main-content-wrapper"
>
  <router-outlet></router-outlet>
</main>
